import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AiChatBotComponent, { Mode, RenderMode, ProxyApp } from '@tylertech/ai-chatbot-component';

import { replaceVif, setVisualizationType } from '../../../actions';
import { generateVif } from 'common/authoring_workflow/helpers/aiVifHelper';
import { getSampleData } from 'common/soql/data-helpers';
import { hostname, pathname } from 'common/window_location/index';

// TODO! change this comment to trigger an update to the component version in pnpm-workspace.yaml
const AiChatBot = ({ metadata }) => {
  const dispatch = useDispatch();
  const [sampleRows, setSampleRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (metadata && metadata.datasetUid) {
      getSampleData({
        datasetUid: metadata.datasetUid,
        domain: hostname() || metadata.domain,
        limitRows: 10,
      })
        .then((data) => {
          setSampleRows(data);
          setLoading(false);
        })
        .catch(() => {
          const allRows = _.get(metadata, 'data.rows', []) || [];
          setSampleRows(allRows.slice(0, 10));
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [metadata]);

  const onUpdateVif = (vif) => {
    const chartType = _.get(vif, 'series[0].type', 'barChart');
    dispatch(setVisualizationType(chartType));
    dispatch(replaceVif(vif));
  };

  const generateVifFunction = ({ vif, vifActionType }) => {
    const newVif = vifActionType == 'update' ? vif : generateVif(vif);
    onUpdateVif(newVif);
  };

  const createVifContext = () => {
    if (!metadata || !metadata.data) return {};

    // Get schema information from columns
    const columns = _.get(metadata, 'data.columns', []);
    const schema = columns.map((column) => ({
      name: column.name,
      dataTypeName: column.dataTypeName,
      fieldName: column.fieldName,
      description: column.description,
    }));

    const sampleData = sampleRows || [];

    // Format dates safely
    let createdAt = '';
    if (metadata.data.createdAt) {
      createdAt =
        typeof metadata.data.createdAt === 'string'
          ? metadata.data.createdAt
          : new Date(metadata.data.createdAt).toISOString();
    }

    let updatedAt = '';
    if (metadata.data.updatedAt) {
      updatedAt =
        typeof metadata.data.updatedAt === 'string'
          ? metadata.data.updatedAt
          : new Date(metadata.data.updatedAt).toISOString();
    }

    // Get domain name from window.location
    const domainName = hostname() || metadata.domain || '';

    // Create the context object
    return {
      domainName: domainName,
      datasetName: metadata.data.name || '',
      datasetId: metadata.data.id || '',
      datasetUid: metadata.datasetUid || '',
      sampleData: sampleData,
      schema: schema,
      datasetOwnerName: _.get(metadata, 'data.owner.displayName', ''),
      datasetCreatedAt: createdAt,
      datasetUpdatedAt: updatedAt,
      viewCount: typeof metadata.data.viewCount === 'number' ? metadata.data.viewCount : 0,
    };
  };

  const vifContext = createVifContext();
  const proxyApp = pathname().includes('/stories/') ? ProxyApp.STORYTELLER : ProxyApp.FRONTEND;

  return (
    <div id="ai-chatbot-container">
      <AiChatBotComponent
        mode={Mode.VIF}
        renderMode={RenderMode.FIXED}
        actionFunction={generateVifFunction}
        appContext={vifContext}
        proxyApp={proxyApp}
      />
    </div>
  );
};

export default AiChatBot;
